<div class="landscape">
    <mat-icon>screen_rotation</mat-icon>
    <span class="screen_rotation_one">{{ 'screen_rotation_one' | translate }}</span>
    <span class="screen_rotation_two">{{ 'screen_rotation_two' | translate }}</span>
</div>